<template>
  <div class="dcb-teaser">
    <Heading
      tag="h1"
      text-uppercase
      class="dcb-teaser__title"
      size="lg"
      spaces-bottom
    >
      Zahl Einfach per Handyrechnung
    </Heading>
    <div class="dcb-teaser__image">
      <CdnImage
        alt="Ein Mann sitzt vor einem Smartphone mit der Aufschrift 'Jetzt kaufen' und hält ein Handy. ."
        render-without-figure
        src="/content/content-images/dcb/16f9871387b7fcfe742048f7401d41ac/zahl-per-handyrechnung-visual.svg"
      />
    </div>
    <div class="cb-teaser__copy">
      Entdecke die neue, bequeme Art des Bezahlens. Mit „Zahl einfach per Handyrechung“ kannst Du
      all Deine Einkäufe direkt über Deine Handyrechnung bezahlen. Keine Kreditkarte, keine
      Anmeldung – absolut einfach.
      <br />
      <br />
      <br />
      <LinkButton
        tag="a"
        primary
        to="#zahlung-per-handyrechnung-nutzen"
        @click.native.prevent="scrollToElement"
      >
        Jetzt einrichten
      </LinkButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { LinkButton, Heading, ImageElement } from '@i22-td-smarthome/component-library';
import CdnImage from '~/components/cdn-image.vue';

const scrollToElement = () => {
  const el = document.getElementById('zahlung-per-handyrechnung-nutzen');
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth' });
};
</script>

<style scoped lang="scss">
@use 'assets/base' as *;

.dcb-teaser {
  margin-bottom: $grid-base * 5;

  @include mq($mq-sm) {
    display: grid;
    grid-template-areas: 'title image' 'copy image';
    grid-template-columns: 1fr 1fr;
  }

  &__title {
    grid-area: title;
    align-self: end;
  }
  &__copy {
    grid-area: copy;
  }
  &__image {
    grid-area: image;
    @include mq($mq-sm) {
      margin-top: $grid-base * 2;
      align-self: center;

      img {
        max-height: 560px;
      }
    }
  }
}
</style>
